import React from 'react';
import PropTypes from 'prop-types';
import MaterialIcon from 'components/common/MaterialIcon';
import {Input, Select} from 'antd';
import uuidv1 from 'uuid/v1';
import Sortable from './Sortable';

@autobind
/**
 *
 */
export default class Signatory extends React.PureComponent {
  static propTypes = {
    disabled: PropTypes.bool,
  };
  static defaultProps = {
    disabled: false,
  };

  /**
   *
   * @param {object} props
   */
  constructor(props) {
    super(props);
    this.items = app.local.load('signatory');
    this.state = {
      items: app._.isEmpty(this.items) ? [] : this.items,
    };
  }

  /**
   *
   */
  componentDidMount() {
  }

  _onAdd(item = {}, callback = () => {
  }) {
    let signatory = app.local.load('signatory');
    let data = app._.isEmpty(signatory) ? [] : signatory;
    data.push(item);
    app.local.save('signatory', data);
    this.setState({items: data}, callback);
  }

  /**
   *
   * @return {XML}
   */
  render() {
    const {items} = this.state;
    return (
      <div
        style={{
          position: 'relative',
        }}>
        <Sortable
          onAdd={this._onAdd}
          items={items}
        />
        {
          this.props.disabled &&
          <div className='disabledBox'/>
        }
      </div>
    );
  }
}
